import { useEffect, useState, useCallback } from 'react';
import { getPracticeByProvider } from 'api/marketing';
import { getGPAdByProviderList } from 'api/operation/group';
import { IPracticeByProviderQuery, IPracticeByProviderRow } from 'types/marketing';

// isOps + organizationId route to the OPS org-scoped endpoint; without them it stays provider-scoped.
const usePracticeByProvider = (
    initialQuery: IPracticeByProviderQuery,
    isOps = false,
    organizationId?: number,
): [IPracticeByProviderRow[], boolean, (params: IPracticeByProviderQuery) => void] => {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState<IPracticeByProviderRow[]>([]);

    const fetchData = useCallback(
        async (params: IPracticeByProviderQuery) => {
            if (isOps && !organizationId) {
                setLoading(false);
                return;
            }
            try {
                setLoading(true);
                const result = isOps
                    ? await getGPAdByProviderList(organizationId!, params)
                    : await getPracticeByProvider(params);
                if (!result.error && result?.data?.data) {
                    setRows(result.data.data);
                }
            } catch (e) {
                console.error(e);
            } finally {
                setLoading(false);
            }
        },
        [isOps, organizationId],
    );

    useEffect(() => {
        fetchData(initialQuery);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOps, organizationId]);

    return [rows, loading, fetchData];
};

export default usePracticeByProvider;
